import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

Vue.filter('priceHeaderMoneyFormat', function (value) {
  let response = 0;
  if (value) {
    response = parseFloat(value);
  }

  // if float has not decimals
  if (response % 1 == 0) {
    return response.toFixed(0).replace('.', ',');
  }
  return response.toFixed(2).replace('.', ',');
});

Vue.filter('customMoneyFormat', function (value) {
  let response = 0;
  if (value) {
    response = parseFloat(value);
  }

  return response.toFixed(2).replace('.', ',');
});

Vue.mixin({
  methods: {
    getTotalPriceForFees(prices) {
      let totalPrice = prices.firstFormPrice;
      if (prices.secondForm && prices.secondForm.secondFormPrice) {
        totalPrice += prices.secondForm.secondFormPrice;
      }

      return totalPrice;
    },
    roundLikePHP(num, dec) {
      let num_sign = num >= 0 ? 1 : -1;
      return parseFloat((Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec));
    },
    calculatePaypalFee(prices) {
      let totalPrice = this.getTotalPriceForFees(prices);
      return this.roundLikePHP(((totalPrice * 0.0249) + 0.35), 2);
    },
    calculateKlarnaFee(prices) {
      let totalPrice = this.getTotalPriceForFees(prices);
      return this.roundLikePHP(((totalPrice * 0.009) + 0.25), 2);
    }
  }
});

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
